import React from 'react';
import { useDispatch } from 'react-redux';

import {
  COMMENT_DESIRABILITY,
  TECH_MODERN_TEMPLATE_NAME,
} from '../../../utils/const';
import SectionHeader from '../../../components/SectionHeader';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';

const DesirabilityTech = ({
  data: { description },
  locales: { portfolio },
  backgroundSection,
  colorPaletteNumber,
}) => {
  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  return (
    <div
      className="desirability-tech relative"
      style={{ background: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_DESIRABILITY} />
      <SectionHeader
        templateName={TECH_MODERN_TEMPLATE_NAME}
        title={portfolio.desirabilitySection.newSectionName}
        description={description}
        onChange={(e) =>
          updateSectionField({
            sectionName: 'desirabilitySection',
            field: 'description',
            name: 'desirabilityText',
            value: e.target.value,
          })
        }
        portfolio={portfolio}
        colorPaletteNumber={colorPaletteNumber}
      />
    </div>
  );
};

export default DesirabilityTech;
